import { render, staticRenderFns } from "./HistorySouthAmount.vue?vue&type=template&id=5c5f5c90"
import script from "./HistorySouthAmount.vue?vue&type=script&lang=js"
export * from "./HistorySouthAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports